export default __webpack_public_path__ + "7997d471e331b516b92a53ce1eba3a4f.jpg";